
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppState } from '@shared/app-state';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'alert',
    templateUrl: "alert.component.html",
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class AlertComponent {

	public showAlert = false;
	public alertMessage = '';
	public showAlertCount = 0;

	constructor(
		public appState: AppState,
		public cookieService: CookieService
	) {	}

	public closeAlert() {
		this.showAlert = false;

	}

}
